import { Service } from '@repo/core'
import { MasterTableItem } from '@repo/shared-types'
import { AxiosInstance } from 'axios'

export const getMasterTable: Service<{ catalog: string }, Array<MasterTableItem>> = async ({
  api,
  params,
}: {
  api: AxiosInstance
  params: { catalog: string }
}) => {
  return await api.get<MasterTableItem[]>(`/catalogs/${params.catalog}`)
}
